import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { fonts } from "../../helpers/fonts"
import { BreakPoints, media } from "../../helpers/rwd"

export const SectionWrapperStyles = css`
`
export const NewContentStyles = css`
  ${media.max(BreakPoints.phone)} {
    padding: 13px 0;
  }
`
export const NewsWrapperStyles = css`
  margin: 0;
`
export const SectionNameStyles = css`
  margin: 48px 0 26px 31px;
  color: ${colors.white};
  font-size: 1.25em;
  font-weight: 700;
  line-height: 1.75em;
`
export const NewLeftBlockStyles = css`
`
export const NewRightBlockStyles = css`
`

export const NewAssetWrapperStyles = css`
  width: 100%;
  overflow: hidden;
`

export const NewAssetStyles = css`
  width: 100%;
  ${media.max(BreakPoints.desktop)} {
    width: 130%;
    margin-left: -39px;
  }
  ${media.max(BreakPoints.phone)} {
    width: 100%;
    margin-left: 1px;
  }
`
export const NewTitleStyles = css`
  margin: 1px;
  color: ${colors.white};
  font-size: 1.05em;
  font-weight: ${fonts.weights.light};
  font-family: 'Motiva Sans', sans-serif;
  line-height: 1.5em;
  ${media.max(BreakPoints.phone)} {
    font-size: 15px;
  }
`
export const LoadMoreButtonStyles = css`
  margin: 73px 0 36px;
  display: flex;
  justify-content: center;
`
export const NewTitleBlockStyles = css`
  background: ${colors.blue};
  padding: 16px;
  min-height: 70px;
`
export const NewGameNameStyles = css`
  margin: 6px 1px 0px;
  color: ${colors.darkGray};
  font-size: 0.8em;
  font-weight: ${fonts.weights.light};
  font-family: 'Motiva Sans', sans-serif;
  line-height: 1.4em;
  display: flex;
  justify-content: space-between;
  ${media.max(BreakPoints.phone)} {
    font-size: 12px;
  }
`

export const NewGameDateStyled = css`
  ${media.max(BreakPoints.phone)} {
    display: none;
  }
`

export const NewDescriptionStyles = css`
  margin: 1px 0;
  color: ${colors.white};
  font-size: 14px;
  font-weight: ${fonts.weights.light};
  ${media.max(BreakPoints.phone)} {
    font-size: 12px;
    line-height: 22px;
  }
`
export const NewInformationBlockStyles = css`
  background: #141414;
  min-height: 93px;
  padding: 16px;
  & > a {
    color: ${colors.yellow};
    font-size: 17px;
    font-weight: ${fonts.weights.medium};
    ${media.max(BreakPoints.phone)} {
      font-size: 15px;
    }
  }
`
